import React from "react";

const PartnerCard = ({ logo, name }) => {
  return (
    <div className="flex flex-col items-center group w-full">
      <div className="h-28 flex items-center justify-center w-full mb-4">
        <img 
          src={logo} 
          alt={name}
          className="h-16 md:h-20 lg:h-24 w-auto object-contain transition-all duration-500 hover:scale-110"
        />
      </div>
      <p className="text-[11px] font-bold uppercase text-slate-500 dark:text-slate-400 tracking-[0.2em] text-center">
        {name}
      </p>
    </div>
  );
};

export default PartnerCard;